module.exports = __webpack_public_path__ + "img/2.46d8f3a0.png";